"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _icon = _interopRequireDefault(require("../icon"));
var _markdown = _interopRequireDefault(require("../markdown"));
var _indexModule = _interopRequireDefault(require("./index.module.scss"));
// HelpText
// ========

const HelpText = _ref => {
  let {
    header,
    text,
    classNames,
    visible,
    onHelpToggle,
    id,
    iconType
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_indexModule.default.helpText, classNames.wrapper, {
      [_indexModule.default.hidden]: !visible
    }),
    "aria-hidden": !visible,
    id: id
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_indexModule.default.header, classNames.header)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_indexModule.default.headerCopy, classNames.headerCopy)
  }, /*#__PURE__*/_react.default.createElement(_icon.default, {
    size: "small",
    className: (0, _classnames.default)(_indexModule.default.helpIcon, classNames.helpIcon),
    type: iconType
  }), /*#__PURE__*/_react.default.createElement("div", null, header)), onHelpToggle && /*#__PURE__*/_react.default.createElement("button", {
    "aria-label": "Close help text",
    onClick: () => onHelpToggle(false)
  }, /*#__PURE__*/_react.default.createElement(_icon.default, {
    size: "small",
    className: (0, _classnames.default)(_indexModule.default.crossIcon, classNames.crossIcon),
    type: "cross"
  }))), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_markdown.default, {
    content: text
  })));
};
HelpText.defaultProps = {
  visible: false,
  classNames: {},
  iconType: 'question-mark'
};
HelpText.propTypes = {
  header: _propTypes.default.string,
  text: _propTypes.default.string,
  classNames: _propTypes.default.shape({
    wrapper: _propTypes.default.string,
    header: _propTypes.default.string,
    headerCopy: _propTypes.default.string,
    crossIcon: _propTypes.default.string,
    helpIcon: _propTypes.default.string
  }),
  visible: _propTypes.default.bool,
  onHelpToggle: _propTypes.default.func,
  id: _propTypes.default.string,
  iconType: _propTypes.default.string
};
var _default = exports.default = HelpText;